import React from "react";

const PlanStarRatingList: React.FunctionComponent = ({ children }) => {
  return <ul className="PlanStarRatingList">{children}</ul>;
};

export default PlanStarRatingList;
